import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  ArticleReviewArticleSummary,
  listArticlesWithReviews,
} from "#/services/articleReviews";

export function useArticleReviewsArticles() {
  return useQuery<ArticleReviewArticleSummary[]>({
    queryKey: qk.articleReviewsArticles(),
    queryFn: ({ signal }) => listArticlesWithReviews({ signal }),
    staleTime: 30_000,
  });
}

export default useArticleReviewsArticles;
